"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputEventInfo = void 0;
var InputEventInfo = /** @class */ (function () {
    function InputEventInfo(descriptor, callback) {
        this.descriptor = descriptor;
        this.callback = callback;
    }
    InputEventInfo.prototype.shouldTrigger = function (eventDescriptor) {
        // check event type: i.e. "keydown", "keyup"
        if (this.descriptor.eventType !== eventDescriptor.eventType) {
            return false;
        }
        // Check if modifiers are matching
        var modifiersMatch = this.descriptor.modifiers.ctrl === eventDescriptor.modifiers.ctrl &&
            this.descriptor.modifiers.shift === eventDescriptor.modifiers.shift &&
            this.descriptor.modifiers.alt === eventDescriptor.modifiers.alt &&
            this.descriptor.modifiers.meta === eventDescriptor.modifiers.meta;
        if (!modifiersMatch) {
            return false;
        }
        // If the code is undefined, it means any key is acceptable
        if (this.descriptor.code === undefined) {
            return true;
        }
        // otherwise compare the keyboard event code
        return this.descriptor.code === eventDescriptor.code;
    };
    return InputEventInfo;
}());
exports.InputEventInfo = InputEventInfo;
//# sourceMappingURL=event.info.js.map